<template>
  <v-row v-scroll="onScroll">
    <!-- header -->
    <mini-header title="Resumen del Documento" :breadcrumbs="breadcrumbs" :breadcrumbsItemDinamic="{ loading: loadingDetail, text: `${activeDocument?.name} Nº ${instance.number}`}" :dense="true" :hiddenTab="true" :addPadding="true" :scroll="scroll">
      <template v-slot:main>
        <v-btn class="mr-2" @click="retrieve" outlined>
          <v-img contain :src="require(`@/assets/icon-update${$vuetify.theme.dark ? '-dark' : ''}.svg`)" />
        </v-btn>
        <v-menu close-on-click close-on-content-click offset-y left :nudge-bottom="10" transition="slide-y-transition">
          <template v-slot:activator="{ on, attrs }">
            <v-btn class="mr-2" outlined v-bind="attrs" v-on="on">
              <v-icon left>mdi-plus-box </v-icon>Opciones<v-icon size="18" right>mdi-chevron-down</v-icon>
            </v-btn>
          </template>
          <v-list class="pa-0">
            <template v-if="$vuetify.breakpoint.width <= 1920">
              <v-list-item class="px-3" @click="downloadFile2('documents', `${instance.type}_${instance.number}`)" :ripple="false">
                <v-list-item-title class="d-flex align-center body-1 grey-500--text"><v-icon color="grey-700" size="20" left>mdi-code-braces-box</v-icon>Descargar documento</v-list-item-title>
              </v-list-item>
              <v-list-item class="px-3" v-if="['APR', 'OBS'].includes(instance.status) && $store?.state?.auth?.account?.country === 'PE'" @click="downloadFile2('documents', `${instance.type}_${instance.number}`, null, 'voucher')" :ripple="false">
                <v-list-item-title class="d-flex align-center body-1 grey-500--text"><v-icon color="grey-700" size="20" left>mdi-code-braces-box</v-icon>Descargar CDR</v-list-item-title>
              </v-list-item>
              <v-list-item class="px-3" v-if="instance.assignment_agency_status" @click="downloadFile2('documents', `${instance.type}_${instance.number}_AEC`, null, 'aec')" :ripple="false">
                <v-list-item-title class="d-flex align-center body-1 grey-500--text"><v-icon color="grey-700" size="20" left>mdi-code-braces-box</v-icon>Descargar AEC</v-list-item-title>
              </v-list-item>
              <!-- <v-list-item class="px-3" v-if="['PE31', 'PE09'].includes((instance || {}).type || '')" @click="dialogMarkAsAnulled=true" :disabled="!instance.status || instance.status === 'VOI'" :ripple="false">
                <v-list-item-title class="body-1 grey-500--text">Marcar como nulo</v-list-item-title>
              </v-list-item> -->
              <v-list-item class="px-3" v-if="!['VOI', 'INV', 'APR', 'OBS'].includes(instance.status)" @click="dialogReprocessDoc=true" :ripple="false">
                <v-list-item-title class="body-1 grey-500--text">Re-procesar el documento</v-list-item-title>
              </v-list-item>
            </template>
            <v-list-item class="px-3" click="modalEmail=true" @click="modalEmail=true" :ripple="false">
              <v-list-item-title class="d-flex align-center body-1 grey-500--text"><v-icon color="grey-700" size="20" left>mdi-email</v-icon>Enviar por mail</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
        <template v-if="$vuetify.breakpoint.width > 1920">
          <v-btn class="mx-2" v-if="!['VOI', 'INV', 'APR', 'OBS'].includes(instance.status)" @click="dialogReprocessDoc=true" outlined><v-icon left>mdi-file-refresh</v-icon>Re-procesar el documento</v-btn>
          <v-btn v-if="['APR', 'OBS'].includes(instance.status) && $store?.state?.auth?.account?.country === 'PE'" @click="createExport" class="mr-2" :disabled="loadingDetail" outlined><v-icon left>mdi-download</v-icon>Descargar CDR</v-btn>
          <v-btn class="mr-2" @click="downloadFile2('documents', `${instance.type}_${instance.number}`)" :disabled="loadingDetail" outlined><v-icon left>mdi-download</v-icon>Descargar documento</v-btn>
        </template>
        <v-btn class="ml-2" outlined @click="modalPDF=true"><v-icon left>mdi-text-box</v-icon>Ver PDF</v-btn>
        <v-btn class="ml-2" outlined v-if="(['APR', 'OBS'].includes(instance.status) && ['REJ', null, 'ERR', 'VOI', 'UNK'].includes(instance.assignment_agency_status)) && $store?.state?.auth?.account?.country === 'CL' && ['CL33', 'CL34', 'CL43'].includes(instance.type)" @click="dialogGrant=true">
          <v-icon left>mdi-file</v-icon>Ceder documento
        </v-btn>
        <template v-if="($store.state.auth.account.country !== 'PE' && !loadingDetail)">
          <v-menu close-on-click close-on-content-click offset-y left :nudge-bottom="10" transition="slide-y-transition">
            <template v-slot:activator="{ on, attrs }">
              <v-btn class="ml-2" color="blue-500" v-bind="attrs" v-on="on" :disabled="loadingDetail">
                <v-icon left>mdi-file-plus</v-icon>Crear documento<v-icon size="18" right>mdi-chevron-down</v-icon>
              </v-btn>
            </template>
            <v-list class="pa-0">
              <v-list-item class="px-3" :ripple="false" :to="{ name: 'DocumentsClone', params: { id: instance.id, ...$route.params }, query: { document_type: instance.type } }">
                <v-list-item-title class="body-2">Duplicar</v-list-item-title>
              </v-list-item>
              <v-list-item class="px-3" v-if="instance.type === 'CL52'" :ripple="false" :to="{ name: 'DocumentsClone', params: { id: instance.id, ...$route.params }, query: { document_type: 'CL33', document_parent: instance.type } }">
                <v-list-item-title class="body-2">Facturar guía de despacho</v-list-item-title>
              </v-list-item>
              <template v-if="availableNotes.length > 0">
                <v-list-item class="px-3" v-for="(item, index) in availableNotes" :key="index" :ripple="false" @click="handlerNoteClick(item)">
                  <v-list-item-title class="body-2">{{ getNoteLabel(item) }}</v-list-item-title>
                </v-list-item>
              </template>
            </v-list>
          </v-menu>
        </template>
      </template>
    </mini-header>
    <!-- end header -->

    <v-col class="px-0" style="z-index: 0;">
      <skeleton-detail v-if="loadingDetail" />
      <div class="d-flex" v-else>
        <!-- detail card -->
        <div class="mr-6" style="min-width: 400px;">
          <div style="position:fixed!important;">
            <v-img contain :width="400" :height="110" :src="require(`@/assets/backgrounds/background-document-detail.svg`)">
              <span class="px-4 pt-4 subtitle-2 white--text font-weight-bold d-inline-block text-truncate" style="max-width: 300px;">
                {{instance?.type ?? '' | nameDocumentsType}} Nº{{instance.number}}
              </span>
              <v-row class="ml-2 mt-3" align="end" no-gutters>
                <v-col cols="5" class="py-0 px-2">
                  <span class="d-block body-1 white--text">Total</span>
                  <span class="subtitle-2 white--text">
                    <span class="subtitle-2 white--text">
                      <span class="font-weight-bold">{{instance.amount_total}}</span>
                      <span class="caption">{{instance?.currency || $store?.state?.auth?.account?.base_currency?.id}}</span>
                    </span>
                  </span>
                </v-col>
                <v-col cols="5" class="py-0 px-2">
                  <span class="d-block body-1 white--text">Fecha</span>
                  <span class="subtitle-2 white--text">
                    <span class="font-weight-bold">{{instance.date | date}}</span>
                  </span>
                </v-col>
              </v-row>
            </v-img>
            <v-card class="mt-3 pb-2" v-if="instance.assignee_tax_id" color="#DBE6F8" outlined style="border-color: var(--light-blue-500);">
             <v-row class="px-5 pt-4" align="center" no-gutters>
              <v-col class="pa-0">
                <span class="ml-n1 subtitle-2 blue-500--text font-weight-bold"><v-icon size="18" left color="blue-500">mdi-file-arrow-left-right</v-icon>Información de cesión</span>
              </v-col>
              <v-col class="pa-0 text-right">
                <v-btn text color="blue-500" @click="dialogDetailAssign=true">Ver más información</v-btn>
              </v-col>
             </v-row>
              <v-card-text class="px-5">
                <v-col class="pa-0">
                  <span class="d-block body-1 blue-500--text">{{instance.assignee_name || 'Sin definir'}}</span>
                  <span class="subtitle-2 blue-500--text">
                    <span class="font-weight-bold">{{formatRut(instance.assignee_tax_id) || 'Sin definir'}}</span>
                  </span>
                </v-col>
                <v-row class="mt-5" no-gutters align="center">
                  <v-col cols="8" class="pa-0">
                  <span class="d-block body-1 blue-500--text">Fecha de cesión</span>
                  <span class="subtitle-2 blue-500--text">
                    <span class="font-weight-bold">{{instance.assignment_date | dateTimeSecond}}</span>
                  </span>
                </v-col>
                <v-col class="pa-0">
                  <span class="d-block body-1 blue-500--text">Estado</span>
                  <chip-status :status="instance.assignment_agency_status" :showDetail="true"  :isTooltip="false" type="assign" />
                </v-col>
                </v-row>
              </v-card-text>
            </v-card>
            <v-card class="pa-0 mt-4" width="400" transition="slide-y-transition" :min-height="instance.assignee_tax_id ? 'calc(100% - 585px)' : 'calc(100% - 295px)'" flat style="position:fixed!important;">
            <v-toolbar color="transparent" flat height="46">
              <v-toolbar-title class="px-5 subtitle-2 grey-500--text font-weight-bold">Resumen del documento</v-toolbar-title>
            </v-toolbar>
            <v-card-text class="overflow-y-auto pa-0" :style="$vuetify.breakpoint.height <= 700 ? ` max-height: calc(100vh - ${instance.assignee_tax_id ? '530px' : '320px'})` : `max-height: calc(100vh - ${instance.assignee_tax_id ? '300px' : '300px'})`">
              <v-divider />
              <!-- detail -->
              <div class="py-4 px-5">
                <v-list class="v-list-form-main transparent pa-0">
                  <v-list-item class="pa-0">
                    <v-list-item-title class="grey-500--text subtitle-2">Razón Social</v-list-item-title>
                    <v-list-item-subtitle class="body-1">{{(instance || {}).customer_name }}</v-list-item-subtitle>
                  </v-list-item>
                  <v-list-item class="pa-0">
                    <v-list-item-title class="grey-500--text subtitle-2">{{$t('generals.RUT')}}</v-list-item-title>
                    <v-list-item-subtitle class="body-1">{{ formatRut((instance || {}).customer_tax_id) }}</v-list-item-subtitle>
                  </v-list-item>
                  <v-list-item class="pa-0">
                    <v-list-item-title class="grey-500--text subtitle-2">Tipo de documento</v-list-item-title>
                    <v-list-item-subtitle class="body-1">{{((instance || {}).type || '') | nameDocumentsType}}</v-list-item-subtitle>
                  </v-list-item>
                  <v-list-item class="pa-0" v-if="instance.status !== 'draft'">
                    <v-list-item-title class="grey-500--text subtitle-2">{{$t('generals.Folio')}}</v-list-item-title>
                    <v-list-item-subtitle class="body-1">{{instance.number}}</v-list-item-subtitle>
                  </v-list-item>
                  <v-list-item class="pa-0">
                    <v-list-item-title class="grey-500--text subtitle-2">ID</v-list-item-title>
                    <v-list-item-subtitle class="body-1">
                      <v-tooltip color="grey-background" right transition="scale-transition" max-width="300">
                        <template v-slot:activator="{on}">
                          <v-btn class="grey-300--text" @click="toClipboard(instance.id)" text v-on="on" :ripple="false">{{instance.id}}</v-btn>
                        </template>
                        <span class="d-block px-3 py-2">Copiar</span>
                      </v-tooltip>
                    </v-list-item-subtitle>
                  </v-list-item>
                  <v-list-item class="pa-0">
                    <v-list-item-title class="grey-500--text subtitle-2">Creado el</v-list-item-title>
                    <v-list-item-subtitle class="body-1">{{instance.created | dateTimeSecond}}</v-list-item-subtitle>
                  </v-list-item>
                  <v-list-item class="pa-0" v-if="instance.summary_id">
                    <v-list-item-title class="grey-500--text subtitle-2">{{ ['PE20', 'P40'].includes(instance.type) ? 'Reversión' : 'Baja' }}</v-list-item-title>
                    <v-list-item-subtitle class="body-1">
                      <router-link :to="{name: 'SummariesRetrieve', params: {id: instance.summary_id, ...currentParams} }" class="d-flex align-center blue-500--text text-decoration-none">
                        {{instance.summary_id}}
                        <v-icon right color="blue-500" size="14">mdi-open-in-new</v-icon>
                      </router-link>
                    </v-list-item-subtitle>
                  </v-list-item>
                  <v-list-item class="pa-0" v-if="instance?.batch_id">
                    <v-list-item-title class="grey-500--text subtitle-2">Lote</v-list-item-title>
                    <v-list-item-subtitle class="body-1">
                      <router-link :to="{name: 'DocumentsBatchRetrieve', params: {id: instance.batch_id, ...currentParams} }" class="d-flex align-center blue-500--text text-decoration-none">
                        {{instance.batch_id}}
                        <v-icon right color="blue-500" size="14">mdi-open-in-new</v-icon>
                      </router-link>
                    </v-list-item-subtitle>
                  </v-list-item>
                </v-list>
              </div>
              <!-- end detail -->

              <!-- totals -->
              <v-col class="px-5">
                <v-row no-gutters align="center" justify="space-between">
                  <v-col class="pa-0">
                    <span class="ml-n1 subtitle-2 grey-700--text font-weight-bold"><v-icon size="18" left color="grey-700">mdi-currency-usd</v-icon>Totales</span>
                  </v-col>
                </v-row>
                <v-divider class="my-3" />
                <v-list class="transparent pa-0" width="100%">
                  <v-list-item>
                    <v-list-item-title class="subtitle-2">Subtotal</v-list-item-title>
                    <v-list-item-subtitle class="text-right font-weight-bold">{{instance.amount_subtotal | currency(((instance || {}).type || ''))}}</v-list-item-subtitle>
                  </v-list-item>
                  <v-list-item>
                    <v-list-item-title class="subtitle-2">Descuento</v-list-item-title>
                    <v-list-item-subtitle class="text-right grey-500--text font-weight-bold">
                      <template v-if="(instance || {}).amount_discount">
                        {{instance.amount_discount}}
                        <template v-if="instance.discount_scheme === '%'">{{instance.discount_scheme}}</template>
                        <template v-if="instance.discount_scheme === '$'">{{((instance || {}).type || '') | firstDocumentsTypeCurrency}}</template>
                      </template>
                      <template v-else>-</template>
                    </v-list-item-subtitle>
                  </v-list-item>
                  <template v-if="(activeDocument || {}).has_taxes_detail">
                    <v-list-item class="mt-3">
                      <v-list-item-title class="subtitle-2">Exento</v-list-item-title>
                      <v-list-item-subtitle class="text-right grey-500--text font-weight-bold">{{instance?.amount_exempt ?? 0 | currency(((instance || {}).type || ''))}}</v-list-item-subtitle>
                    </v-list-item>
                    <template v-if="(activeDocument || {}).has_taxes">
                      <v-list-item>
                        <v-list-item-title class="subtitle-2">Neto</v-list-item-title>
                        <v-list-item-subtitle class="text-right grey-500--text font-weight-bold">{{instance.amount_net | currency(((instance || {}).type || ''))}}</v-list-item-subtitle>
                      </v-list-item>
                      <v-list-item class="mt-3">
                        <v-list-item-title class="subtitle-2">Impuestos ({{activeDocument.tax}}%)</v-list-item-title>
                        <v-list-item-subtitle class="text-right grey-500--text font-weight-bold">{{instance.amount_tax | currency(((instance || {}).type || ''))}}</v-list-item-subtitle>
                      </v-list-item>
                    </template>
                  </template>
                  <v-list-item class="mt-3">
                    <v-list-item-title class="subtitle-2 grey-500--text font-weight-bold subtitle-2">Total documento</v-list-item-title>
                    <v-list-item-subtitle class="text-right subtitle-2 grey-500--text font-weight-bold">{{instance.amount_total}} {{instance?.currency || $store?.state?.auth?.account?.base_currency?.id}}</v-list-item-subtitle>
                  </v-list-item>
                </v-list>
              </v-col>
              <!-- end totals -->
            </v-card-text>
          </v-card>
        </div>
        </div>
        <!-- detail card -->

        <!-- panels -->
        <div class="pb-5" style="flex:1; min-width: 180px;">

        <!-- SII / SUNAT -->
          <v-card class="mt-1" flat>
            <v-toolbar color="transparent" flat height="46">
              <v-toolbar-title class="px-5 subtitle-2 grey-700--text font-weight-semibold">
                <v-row align="center" no-gutters>
                  <img class="ml-n1 mr-2" :width="20" :src="require(`@/assets/ax/${$store?.state?.auth?.account?.country === 'PE' ? 'sunat' : 'sii'}--icon.png`)" />
                  {{ $store?.state?.auth?.account?.country === 'PE' ? 'Sunat' : 'Servicio de impuestos internos' }}
                </v-row>
              </v-toolbar-title>
            </v-toolbar>
            <v-divider />
            <v-card-text class="pa-0">
              <div class="pt-4 px-5 pb-2">
                <v-list class="v-list-form-status transparent pa-0">
                  <v-list-item class="pa-0">
                    <v-list-item-title class="grey-500--text subtitle-2 font-weight-bold"><v-icon class="mr-3" size="20" left color="blue-500">mdi-clipboard</v-icon>Estado</v-list-item-title>
                    <v-list-item-subtitle class="body-1">
                      <v-btn v-if="!instance.status || instance?.status?.code === 'IMP'" @click="taxAgencyService('documents', 'documents', 'irs_status')" :loading="taxAgencyLoader" text color="blue-500" :ripple="false">Actualizar estado</v-btn>
                      <span v-else-if="instance?.status?.id === 'PDR'" class="body-2 text--disabled d-block" >Sin estado</span>
                      <chip-status v-else :status="instance?.status?.code || instance.status" :detail="instance.agency_status || instance.agency_status_info ? `${instance.agency_status} <br> ${instance.agency_status_info}` : null"  :showDetail="true" :isTooltip="false" type="documents" />
                    </v-list-item-subtitle>
                  </v-list-item>
                  <v-list-item class="pa-0" v-if="(instance || {}).agency_status">
                    <v-list-item-title class="grey-500--text subtitle-2 font-weight-bold"><v-icon class="mr-3" size="20" left color="blue-500">mdi-clipboard-search</v-icon>Detalle del estado</v-list-item-title>
                    <v-list-item-subtitle class="body-1 align-self-start mt-2" style="white-space: normal !important">{{instance.agency_status}}</v-list-item-subtitle>
                  </v-list-item>
                  <v-list-item class="pa-0" v-if="(instance || {}).agency_status_info">
                    <v-list-item-title class="grey-500--text subtitle-2"></v-list-item-title>
                    <v-list-item-subtitle class="body-1 align-self-start" style="white-space: normal !important">
                      <!-- <v-tooltip color="grey-background" right transition="scale-transition" max-width="500">
                        <template v-slot:activator="{on}"> v-on="instance.agency_status_info.length >= 256 ? on : false"-->
                          <v-sheet class="grey-300--text" style="justify-content: left;">
                            <span class="">{{instance.agency_status_info.slice(0, 256)}} {{ instance.agency_status_info.length >= 256 ? '...' : ''}}</span>
                          </v-sheet>
                        <!-- </template>
                        <span class="d-block px-3 py-2">{{instance.agency_status_info}}</span>
                      </v-tooltip> -->
                    </v-list-item-subtitle>
                  </v-list-item>
                  <!-- agency_status_detail_list -->
                  <v-list-item class="pa-0" v-if="(instance || {})?.agency_status_detail_list">
                    <v-list-item-title class="grey-500--text subtitle-2"></v-list-item-title>
                    <v-list-item-subtitle class="body-1 align-self-start mt-2" v-if="(instance || {}).agency_status_detail_list" style="white-space: normal !important">
                      <span class="d-block mb-2" v-for="(detail, i) in instance?.agency_status_detail_list.slice(0,2)" :key="i">{{ detail.slice(0, 156) && i === instance.agency_status_detail_list.slice(0,2).length - 1  && detail.length >= 156 ? `${detail}...` : detail}}</span>
                      <v-btn text color="blue-500" v-if="instance.agency_status_detail_list.length >=2" @click="dialogSunat=true">Ver más</v-btn>
                    </v-list-item-subtitle>
                  </v-list-item>
                  <v-list-item class="pa-0" v-if="$store.state.auth.account.country !== 'PE'">
                    <v-list-item-title class="grey-500--text subtitle-2 font-weight-bold"><v-icon class="mr-3" size="20" left color="blue-500">mdi-pound</v-icon>Track ID</v-list-item-title>
                    <v-list-item-subtitle class="body-1">
                      <v-tooltip v-if="instance?.agency_id" color="grey-background" right transition="scale-transition" max-width="300">
                        <template v-slot:activator="{on}">
                          <v-btn class="grey-300--text" @click="toClipboard(instance?.agency_id)" text v-on="on" :ripple="false" style="justify-content: left;">{{instance?.agency_id}}</v-btn>
                        </template>
                        <span class="d-block px-3 py-2">Copiar</span>
                      </v-tooltip>
                    </v-list-item-subtitle>
                  </v-list-item>
                </v-list>
              </div>
            </v-card-text>
          </v-card>
          <!-- end SII / SUNAT -->

          <!-- comercial -->
          <v-card class="mt-5" flat v-if="instance?.rec_status">
            <v-toolbar color="transparent" flat height="46">
              <v-toolbar-title class="px-5 subtitle-2 grey-700--text font-weight-semibold"><v-icon size="18" left color="grey-700">mdi-domain</v-icon>Respuesta comercial</v-toolbar-title>
            </v-toolbar>
            <v-divider />
            <v-card-text class="pa-0">
              <div class="pt-4 px-5 pb-2">
                <v-list class="v-list-form-status transparent pa-0">
                  <v-list-item class="pa-0">
                    <v-list-item-title class="grey-500--text subtitle-2 font-weight-bold"><v-icon class="mr-3" size="20" left color="blue-500">mdi-clipboard</v-icon>Estado</v-list-item-title>
                    <v-list-item-subtitle class="body-1">
                      <chip-status :status="instance?.rec_status" :detail="instance?.rec_status_info || null" type="purchases" :showDetail="true" :isTooltip="false" />
                    </v-list-item-subtitle>
                  </v-list-item>
                  <v-list-item class="pa-0" v-if="instance?.rec_status_info">
                    <v-list-item-title class="grey-500--text subtitle-2 font-weight-bold"><v-icon class="mr-3" size="20" left color="blue-500">mdi-clipboard-search</v-icon>Detalle del estado</v-list-item-title>
                    <v-list-item-subtitle class="body-1 align-self-start mt-2" style="white-space: normal !important">
                      <span class="d-block body-2 grey-300--text" v-if="instance.rec_status_info">{{instance.rec_status_info}}</span>
                      <span class="body-2 text--disabled font-italic" v-else>Sin especificar</span>
                    </v-list-item-subtitle>
                  </v-list-item>
                  <v-list-item class="pa-0">
                    <v-list-item-title class="grey-500--text subtitle-2 font-weight-bold"><v-icon class="mr-3" size="20" left color="blue-500">mdi-calendar-blank</v-icon>Fecha</v-list-item-title>
                    <v-list-item-subtitle class="body-1">
                      <span class="d-block body-2 grey-300--text" v-if="instance.rec_status_date">{{instance.rec_status_date | dateTimeSecond}}</span>
                      <span class="body-2 text--disabled font-italic" v-else>Sin especificar</span>
                    </v-list-item-subtitle>
                  </v-list-item>
                </v-list>
              </div>
            </v-card-text>
          </v-card>
          <!-- end comercial -->

          <!-- link -->
          <v-card flat class="mt-5" v-if="instance.pdf_link">
            <v-card-text class="px-7 py-6">
              <v-row align="center">
                <v-icon size="18" left color="grey-700">mdi-link-variant</v-icon>
                <v-col class="pa-0 pr-2">
                  <v-text-field v-model="instance.pdf_link" class="publicLink" outlined readonly type="text" hide-details single-line dense prefix="Enlace público:">
                    <template v-slot:append>
                      <v-btn text @click="toClipboard(instance.pdf_link)" class="pl-4 mr-1 body-2" color="blue-500" style="top:-4px">Copiar</v-btn>
                    </template>
                  </v-text-field>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
          <!-- end link -->

          <!-- events -->
          <v-card flat class="mt-5">
            <v-toolbar color="transparent" flat height="46">
              <v-toolbar-title class="px-5 subtitle-2 grey-700--text font-weight-semibold"><v-icon size="18" left color="grey-700">mdi-timeline-clock</v-icon>Eventos</v-toolbar-title>
            </v-toolbar>
            <v-divider />
            <v-card-text class="pa-0">
              <v-row class="ma-0 pa-0" no-gutters>
                <!-- Documento column -->
                <v-col cols="6" class="pa-0 pb-3 d-flex flex-column">
                  <div class="px-5 pt-5 pb-2 d-flex align-center">
                    <span class="subtitle-2 grey-500--text font-weight-semibold">
                      <v-icon size="16" left color="grey-500">mdi-file</v-icon>Documento
                    </span>
                  </div>
                  <v-skeleton-loader v-if="eventLoading" class="mb-2 panel px-1 rounded-md" transition="fade-transition" type="list" />
                  <template v-else-if="(eventsList || []).length">
                    <v-list class="transparent pa-0 dense">
                      <div v-for="(d, i) in events" :key="i">
                        <v-list-item class="px-5" :key="i">
                          <v-list-item-icon class="pr-2 my-3">
                            <v-avatar size="38" color="blue-500">
                              <v-icon size="22" color="white">{{currentEvent(d.event_type).icon}}</v-icon>
                            </v-avatar>
                          </v-list-item-icon>
                          <v-list-item-title class="ml-n5" style="white-space: normal; overflow: visible; text-overflow: unset;">
                            <span class="d-block grey-700--text body-1">
                              <span v-html="currentEvent(d.event_type).summary"></span>
                              <template v-if="d.description">
                                <span class="text-body-2 grey-700--text"> — {{ d.description }}</span>
                              </template>
                            </span>
                            <span class="d-block body-2 grey-300--text">
                              <v-icon size="14" class="mr-1">mdi-calendar-blank</v-icon>{{d.created | dateTimeSecond}}
                            </span>
                           </v-list-item-title>
                        </v-list-item>
                      </div>
                    </v-list>
                  </template>
                  <div class="d-flex align-center justify-center flex-grow-1 px-5" v-else>
                    <span class="body-2 text--disabled font-italic">Sin eventos de documento</span>
                  </div>
                </v-col>
                <v-divider class="my-0 pa-0" height="100%" vertical />
                <!-- Distribución column -->
                <v-col cols="6" class="pa-0 pb-3 d-flex flex-column">
                  <div class="px-5 pt-5 pb-2 d-flex align-center">
                    <span class="subtitle-2 grey-500--text font-weight-semibold">
                      <v-icon size="16" left color="grey-500">mdi-send</v-icon>Distribución
                    </span>
                  </div>
                  <v-skeleton-loader v-if="distEventLoading" class="mb-2 panel px-1 rounded-md" transition="fade-transition" type="list" />
                  <template v-else-if="distEventsList.length">
                    <v-list class="transparent pa-0 dense">
                      <div v-for="(d, i) in distEvents" :key="'dist-' + i">
                        <v-list-item class="px-5 py-0">
                          <v-list-item-icon class="pr-2 my-3">
                            <v-avatar size="38" color="blue-500">
                              <v-icon size="22" color="white">{{ currentDistEvent(d.source_type).icon || 'mdi-email-outline' }}</v-icon>
                            </v-avatar>
                          </v-list-item-icon>
                          <v-list-item-title class="ml-n5" style="white-space: normal; overflow: visible; text-overflow: unset;">
                            <span class="d-block grey-700--text body-1">
                              <span class="font-weight-bold">{{ distEventTypeLabel(d.dist_event_type) }}</span>
                              <span v-if="['SNT', 'NST'].includes(d.dist_event_type)" class="blue-200--text font-weight-bold"> {{ distSourceTypeLabel(d.source_type) }}</span>
                              <span v-if="d.address && d.address.trim()"> a {{ d.address }}</span>
                            </span>
                            <span class="d-block body-2 grey-300--text">
                              <v-icon size="14" class="mr-1">mdi-calendar-blank</v-icon>{{ d.timestamp | dateTimeSecond }}
                            </span>
                          </v-list-item-title>
                        </v-list-item>
                      </div>
                    </v-list>
                  </template>
                  <div class="d-flex align-center justify-center flex-grow-1 px-5" v-else>
                    <span class="body-2 text--disabled font-italic">Sin eventos de distribución</span>
                  </div>
                </v-col>
              </v-row>
            </v-card-text>
            <template v-if="eventsList.length > 3 || distEventsList.length > 3">
            <v-divider />
            <v-card-actions class="px-5 py-2">
              <v-spacer />
              <v-btn color="blue-500" @click="showMoreEvents=!showMoreEvents; showMoreDistEvents=!showMoreDistEvents" text>
                {{ !showMoreEvents ? 'Ver todos los eventos' : 'Ver menos eventos' }}
              </v-btn>
            </v-card-actions>
            </template>
          </v-card>
          <!-- end events -->

          <!-- related documents -->
          <v-expansion-panels class="mt-5" v-model="panelRelatedDocuments">
            <v-expansion-panel>
              <v-expansion-panel-header class="px-4 py-3">
                <v-row no-gutters align="center" justify="space-between">
                  <span class="subtitle-2 grey-700--text font-weight-bold d-flex align-center"><v-icon size="18" left color="grey-700">mdi-file-document-multiple</v-icon>Referencias</span>
                </v-row>
              </v-expansion-panel-header>
              <v-expansion-panel-content class="px-0">
                <v-empty-state class="mt-n2 pb-2" v-if="!references?.length" type="documents" id="documentos" customClass="mt-n5" :isFree="true" title="No hay información de referencias" :height="199" />
                <v-simple-table class="px-0 no-hover table-not-rounded" dense v-else>
                  <template v-slot:default>
                    <thead>
                      <tr>
                        <th class="text-left grey-700--text font-weight-medium" style="min-width: 180px;">Tipo de documento</th>
                        <th class="text-right grey-700--text font-weight-medium" style="min-width: 120px;">{{ $t('generals.Correlativo') }}</th>
                        <th class="text-right grey-700--text font-weight-medium" style="min-width: 70px;">Fecha del doc.</th>
                      </tr>
                      <v-divider style="position: absolute;  margin-top: -10px; min-width: 100%; margin-left: -1px" />
                    </thead>
                    <tbody>
                      <tr
                        v-for="item in references"
                        :key="item.number"
                        style="cursor: pointer"
                        @click="goTo(item)"
                      >
                        <td class="body-2">
                          <span class="d-inline-block text-truncate" style="max-width: 99%;" v-if="item.type">
                            <span v-if="$store.state.auth.account.country !== 'PE'">{{item.type | nameReferencesType}}</span>
                            <span v-else>{{item.type | nameDocumentsType }}</span>
                          </span>
                          <span class="body-2 text--disabled font-italic" v-else>Sin especificar</span>
                        </td>
                        <td class="text-right body-2">
                          <span>{{item.number}}</span>
                        </td>
                        <td class="text-right body-2">
                          <span v-if="item.date">{{item.date | date}}</span>
                        </td>
                      </tr>
                    </tbody>
                  </template>
                </v-simple-table>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        <!-- end related documents -->
        </div>
        <!-- end panels -->
      </div>
    </v-col>
    <!-- dialog grant -->
    <v-dialog v-model="dialogGrant" width="600" persistent no-click-animation scrollable overlay-color="grey-500">
      <v-card class="pa-0">
        <v-toolbar flat height="46" class="transparent">
          <v-toolbar-title class="px-5 subtitle-2 grey-500--text font-weight-semibold">Ceder documento</v-toolbar-title>
          <v-spacer />
          <v-toolbar-items>
            <v-row align="center" justify="center" class="mr-3">
              <v-btn @click="dialogGrant=false" icon small retain-focus-on-click><v-icon color="grey-500" size="20">mdi-close</v-icon></v-btn>
            </v-row>
          </v-toolbar-items>
        </v-toolbar>
        <v-divider />
        <v-card-text class="px-0 py-4">
          <v-row no-gutters>
            <v-col class="pa-0">
              <v-list class="v-list-form-extended transparent pa-0">
                <v-list-item class="px-5 pt-0">
                  <v-list-item-title>
                    <span class="font-weight-bold">Cedida a</span>
                  </v-list-item-title>
                </v-list-item>
                <v-list-item class="px-5">
                  <v-list-item-title>{{$t('generals.RUT')}}</v-list-item-title>
                  <v-list-item-subtitle>
                    <v-col cols="6">
                      <v-text-field v-model="$v.grant.assigneeTaxId.$model" :error="$v.grant.assigneeTaxId.$error" v-dni="'CL'" outlined hide-details required single-line dense maxlength="32" />
                    </v-col>
                  </v-list-item-subtitle>
                </v-list-item>
                <v-list-item class="py-2 px-5">
                  <v-list-item-title>Nombre</v-list-item-title>
                  <v-list-item-subtitle>
                    <v-text-field v-model="$v.grant.assigneeName.$model" :error="$v.grant.assigneeName.$error" outlined hide-details required single-line dense maxlength="100" />
                  </v-list-item-subtitle>
                </v-list-item>
                <v-list-item class="px-5">
                  <v-list-item-title>Email</v-list-item-title>
                  <v-list-item-subtitle>
                    <v-text-field v-model="$v.grant.assigneeEmail.$model" :error="$v.grant.assigneeEmail.$error" outlined hide-details required single-line dense maxlength="70" />
                  </v-list-item-subtitle>
                </v-list-item>
                <v-list-item class="py-2 px-5">
                  <v-list-item-title>Dirección</v-list-item-title>
                  <v-list-item-subtitle>
                    <v-text-field v-model="$v.grant.assigneeAddress.$model" :error="$v.grant.assigneeAddress.$error" outlined hide-details required single-line dense maxlength="70" />
                  </v-list-item-subtitle>
                </v-list-item>
                <v-divider class="my-3" />
                <v-list-item class="px-5">
                  <v-list-item-title>
                    <span class="font-weight-bold">Cedida por</span>
                  </v-list-item-title>
                </v-list-item>
                <v-list-item class="pt-2 pb-1 px-5">
                  <v-list-item-title>Email</v-list-item-title>
                  <v-list-item-subtitle>
                    <v-text-field v-model="$v.grant.assignorEmail.$model" :error="$v.grant.assignorEmail.$error" outlined hide-details required single-line dense maxlength="70" />
                  </v-list-item-subtitle>
                </v-list-item>
                <v-list-item class="py-2 px-5">
                  <v-list-item-title>Nombre</v-list-item-title>
                  <v-list-item-subtitle>
                    <v-text-field v-model="$v.grant.assignorName.$model" :error="$v.grant.assignorName.$error" outlined hide-details required single-line dense maxlength="100" readonly />
                  </v-list-item-subtitle>
                </v-list-item>
                <v-list-item class="px-5">
                  <v-list-item-title>{{$t('generals.RUT')}}</v-list-item-title>
                  <v-list-item-subtitle>
                    <v-col cols="6">
                      <v-text-field v-model="$v.grant.assignorTaxId.$model" :error="$v.grant.assignorTaxId.$error" v-dni="'CL'" outlined hide-details required single-line dense maxlength="70" readonly />
                    </v-col>
                  </v-list-item-subtitle>
                </v-list-item>
              </v-list>
            </v-col>
          </v-row>
        </v-card-text>
        <v-divider />
        <v-card-actions class="px-5 py-2">
          <v-spacer />
          <v-btn @click="dialogGrant=false" outlined>Cancelar</v-btn>
          <v-btn @click="createGrant" color="blue-500">Ceder documento</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- end dialog grant -->

    <!-- dialog loading assign -->
    <v-dialog v-model="dialogLoadingAssign" width="590" persistent scrollable no-click-animation overlay-color="grey-500">
      <v-card>
        <v-card-text class="px-6 py-6">
          <v-row class="pt-2 pb-4" align="center">
            <v-col cols="2" class="pr-0">
              <v-progress-circular indeterminate color="blue-500" :width="8" size="48" />
            </v-col>
            <v-col class="pl-0">
              <span class="d-block body-1 font-weight-bold pt-2 text-grey-700--text">Procesando tu solicitud...</span>
              <span class="d-block body-2 mt-1 text-grey-500--text">La cesión del documento se está ejecutando</span>
            </v-col>
          </v-row>
          <!-- alert -->
          <v-alert class="inf-alert-blue blue-500--text rounded-md mt-2" :height="62" dense text>
            <div class="d-flex pa-0 my-1">
              <v-icon color="blue-500" size="22">mdi-information-outline</v-icon>
              <div class="ml-4">
                <span class="body-2" style="line-height: 14px;">Esta proceso
                  <span class="font-weight-bold">podría tardar varios minutos</span> en completarse.
                  <span class="font-weight-bold">El estado se actualizará automáticamente </span> en el documento.
                </span>
              </div>
            </div>
          </v-alert>
          <!-- end alert -->
        </v-card-text>
      </v-card>
    </v-dialog>
    <!-- end dialog loading assign -->

    <!-- dialog detail assign -->
    <v-dialog v-model="dialogDetailAssign" width="600" persistent no-click-animation scrollable overlay-color="grey-500">
      <v-card class="pa-0">
        <v-toolbar flat height="46" class="transparent">
          <v-toolbar-title class="px-5 subtitle-2 grey-500--text font-weight-semibold">Información de cesión</v-toolbar-title>
          <v-spacer />
          <v-toolbar-items>
            <v-row align="center" justify="center" class="mr-3">
              <v-btn @click="dialogDetailAssign=false" icon small retain-focus-on-click><v-icon color="grey-500" size="20">mdi-close</v-icon></v-btn>
            </v-row>
          </v-toolbar-items>
        </v-toolbar>
        <v-divider />
        <v-card-text class="px-0 py-4">
          <div class="px-5 pb-2">
            <v-list class="v-list-form-main transparent pa-0">
              <v-list-item class="pa-0">
                <v-list-item-title class="grey-500--text subtitle-2 font-weight-bold"><v-icon class="mr-3" size="20" left color="grey-500">mdi-clipboard</v-icon>Estado</v-list-item-title>
                <v-list-item-subtitle class="body-1">
                  <chip-status :status="instance.assignment_agency_status" :showDetail="true" :isTooltip="false" type="assign" />
                </v-list-item-subtitle>
              </v-list-item>
              <v-list-item class="pa-0">
                <v-list-item-title class="grey-500--text subtitle-2 font-weight-bold"><v-icon class="mr-3" size="20" left color="grey-500">mdi-clipboard-search</v-icon>Detalle del estado</v-list-item-title>
                <v-list-item-subtitle class="body-1 align-self-start mt-2" style="white-space: normal !important">
                  <span v-if="instance?.assignment_agency_status_code">{{instance.assignment_agency_status_code}}</span>
                  <span v-else class="body-2 text--disabled font-italic d-block">Sin definir</span>
                </v-list-item-subtitle>
              </v-list-item>
              <v-list-item class="pa-0">
                <v-list-item-title class="grey-500--text subtitle-2 font-weight-bold"><v-icon class="mr-3" size="20" left color="grey-500">mdi-clipboard-list</v-icon>Track ID</v-list-item-title>
                <v-list-item-subtitle class="body-1">
                  <v-tooltip v-if="instance?.assignment_agency_id" color="grey-background" right transition="scale-transition" max-width="300">
                    <template v-slot:activator="{on}">
                      <v-btn class="grey-300--text" @click="toClipboard(instance?.assignment_agency_id)" text v-on="on" :ripple="false" style="justify-content: left;">{{instance?.assignment_agency_id}}</v-btn>
                    </template>
                    <span class="d-block px-3 py-2">Copiar</span>
                  </v-tooltip>
                  <span v-else class="body-2 text--disabled font-italic d-block">Sin definir</span>
                </v-list-item-subtitle>
              </v-list-item>
            </v-list>
          </div>
          <v-divider />
          <v-col class="px-6 mb-4">
            <v-list-item-title class="mt-2">
              <v-icon size="18" left color="grey-500">mdi-file-arrow-left-right</v-icon>
              <span class="font-weight-bold grey-500--text">Cedida a</span>
            </v-list-item-title>
            <v-row class="mt-3" no-gutters>
              <v-col cols="4" class="pa-0 pr-2">
                <v-list-item-title>{{$t('generals.RUT')}}</v-list-item-title>
                <v-text-field v-model="instance.assignee_tax_id" v-dni="'CL'" outlined hide-details required single-line dense maxlength="32" disabled />
              </v-col>
              <v-col cols="8" class="pa-0 pl-2">
                <v-list-item-title>Razón social</v-list-item-title>
                <v-text-field v-model="instance.assignee_name" outlined hide-details required single-line dense maxlength="32" disabled />
              </v-col>
            </v-row>
            <v-row class="mt-3" no-gutters>
              <v-col cols="4" class="pa-0 pr-2">
                <v-list-item-title>Email</v-list-item-title>
                <v-text-field v-model="instance.assignee_email" outlined hide-details required single-line dense maxlength="32" disabled />
              </v-col>
              <v-col cols="8" class="pa-0 pl-2">
                <v-list-item-title>Dirección</v-list-item-title>
                <v-text-field v-model="instance.assignee_address" outlined hide-details required single-line dense maxlength="32" disabled />
              </v-col>
            </v-row>
          </v-col>
          <v-divider />
          <v-col class="px-6 mt-2">
            <v-list-item-title>
              <v-icon size="18" left color="grey-500">mdi-account</v-icon>
              <span class="font-weight-bold grey-500--text">Cedido por</span>
            </v-list-item-title>
            <v-row class="mt-3" no-gutters>
              <v-col cols="4" class="pa-0 pr-4">
                <v-list-item-title>{{$t('generals.RUT')}}</v-list-item-title>
                <v-text-field v-model="instance.assignor_tax_id" v-dni="'CL'" outlined hide-details required single-line dense maxlength="32" disabled />
              </v-col>
              <v-col cols="4" class="pa-0">
                <v-list-item-title>Nombre</v-list-item-title>
                <v-text-field v-model="instance.assignor_name" outlined hide-details required single-line dense maxlength="32" disabled />
              </v-col>
              <v-col cols="4" class="pa-0 pl-4">
                <v-list-item-title>Email</v-list-item-title>
                <v-text-field v-model="instance.assignor_email" outlined hide-details required single-line dense maxlength="32" disabled />
              </v-col>
            </v-row>
          </v-col>
        </v-card-text>
        <v-divider />
        <v-card-actions class="px-5 py-2">
          <v-spacer />
          <v-btn @click="dialogDetailAssign=false" outlined>Cerrar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- end dialog detail assign -->

    <!-- dialog confirm markAsAnulled -->
    <v-dialog v-model="dialogMarkAsAnulled" width="792" persistent no-click-animation overlay-color="grey-500">
      <v-card>
        <v-card-title class="pa-0">
          <v-toolbar flat height="46" class="transparent">
            <v-toolbar-title class="px-5 subtitle-2 grey-700--text font-weight-semibold">Marcar como nulo</v-toolbar-title>
            <v-spacer />
            <v-toolbar-items>
              <v-row align="center" justify="center" class="mr-3">
                <v-btn @click="dialogMarkAsAnulled=false" icon small retain-focus-on-click><v-icon color="grey-500" size="20">mdi-close</v-icon></v-btn>
              </v-row>
            </v-toolbar-items>
          </v-toolbar>
        </v-card-title>
        <v-divider />
        <v-card-text class="py-4 px-5 grey-500--text">
          <v-row class="pt-2 pb-4" align="center">
            <v-col cols="3">
              <img :src="require(`@/assets/backgrounds/modal-document-null.svg`)" :width="148" />
            </v-col>
            <v-col class="pr-4 pl-4">
              <div class="mt-1 mb-3">
                <v-icon class="mr-2" color="grey-700" size="14">mdi-file-document</v-icon><span class="body-2 font-weight-medium text-uppercase">{{((instance || {}).type || '') | nameDocumentsType}} {{((instance || {}).document_type || '') | nameDocumentsType}} Nº{{instance.number}}</span>
              </div>
              <span class="d-block body-1 pt-2">Al marcar como nulo un documento, sólo lo estás anulando en la plataforma y no en {{$t('generals.SII')}}.</span>
              <span class="d-block body-1 mt-4 mb-3">Escribe <span class="font-weight-bold">“confirmar”</span> para continuar.</span>
              <v-text-field v-model="confirm" outlined single-line maxlength="9" dense hide-details />
            </v-col>
          </v-row>
        </v-card-text>
        <v-divider />
        <v-card-actions class="py-2 px-5">
          <v-spacer/>
          <v-btn @click="dialogMarkAsAnulled=false" outlined>Cancelar</v-btn>
          <v-btn color="blue-500" @click="markAsAnulled" :loading="loadingAnulled" :disabled="confirm.toLowerCase() !== 'confirmar' ">Confirmar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- end dialog confirm markAsAnulled -->

    <!-- dialog create clone document -->
    <v-dialog v-model="createDocumentDialog" width="560" persistent no-click-animation overlay-color="grey-500">
      <v-card>
        <v-card-title class="pa-0">
          <v-toolbar flat height="46" class="transparent">
            <v-toolbar-title class="px-5 subtitle-2 grey-700--text font-weight-semibold">Crear documento</v-toolbar-title>
            <v-spacer />
            <v-toolbar-items>
              <v-row align="center" justify="center" class="mr-3">
                <v-btn @click="closeCreateDocumentDialog" icon small retain-focus-on-click><v-icon color="grey-500" size="20">mdi-close</v-icon></v-btn>
              </v-row>
            </v-toolbar-items>
          </v-toolbar>
        </v-card-title>
        <v-divider />
        <v-card-text class="px-5 py-4">
          <v-row class="pt-2" align="center">
            <v-col cols="4">
              <img :src="require(`@/assets/backgrounds/modal-document-clone.svg`)" :width="148" />
            </v-col>
            <v-col class="pr-4 pl-4">
              <v-list class="v-list-form pa-0 transparent">
                <v-list-item class="pa-0 mb-4">
                  <v-list-item-content>
                    <v-list-item-title class="grey-500--text body-1 font-weight-semibold mb-3" style="white-space: normal; word-wrap: break-word; line-height: 1.4;">Crear {{ ((DocumentTypesList.find(d => d.id === cloneDoc) || {}).name || '').toLowerCase() }}</v-list-item-title>
                    <v-list-item-subtitle class="mt-1 mb-3">
                      <v-radio-group class="ma-0" v-model="actionCreateDoc" column dense hide-details>
                        <v-radio label="Anula documento de referencia" value="1" class="mb-2"></v-radio>
                        <v-radio label="Corrige texto documento de referencia" value="2" class="mb-2"></v-radio>
                        <v-radio label="Corrige montos" value="3"></v-radio>
                      </v-radio-group>
                    </v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
              </v-list>
            </v-col>
          </v-row>
          <span class="mt-n1 d-block grey-700--text body-1">Descripción del documento</span>
          <v-list-item class="pa-0">
            <v-list-item-content>
              <v-text-field
                v-model="noteReason"
                outlined
                dense
                hide-details
                maxlength="90"
              ></v-text-field>
            </v-list-item-content>
          </v-list-item>
        </v-card-text>
        <v-divider />
        <v-card-actions class="py-2 px-5">
          <v-spacer/>
          <v-btn outlined @click="closeCreateDocumentDialog" :ripple="false">Cancelar</v-btn>
          <v-btn
            color="blue-500"
            :disabled="!actionCreateDoc || !noteReason"
            @click="createNoteDocument"
            :ripple="false"
          >
            Crear documento
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- end dialog create clone document -->

   <!-- dialog STATUS SUNAT -->
    <v-dialog v-model="dialogSunat" width="790" persistent scrollable no-click-animation overlay-color="grey-500">
      <v-card>
        <v-card-title class="pa-0">
          <v-toolbar flat height="46" class="transparent">
            <v-toolbar-title class="px-5 subtitle-2 grey-700--text font-weight-semibold">Detalle del estado</v-toolbar-title>
            <v-spacer />
            <v-toolbar-items>
              <v-row align="center" justify="center" class="mr-3">
                <v-btn @click="dialogSunat=false" icon small retain-focus-on-click><v-icon color="grey-500" size="20">mdi-close</v-icon></v-btn>
              </v-row>
            </v-toolbar-items>
          </v-toolbar>
        </v-card-title>
        <v-divider />
        <v-card-text class="px-5 pt-6 pb-0">
          <div v-for="(detail, i) in instance.agency_status_detail_list" :key="i">
            <span class="d-block mb-8">{{detail}}</span>
            <v-sheet class="text-left ml-1 mt-n8 mb-3" v-if="i !== instance.agency_status_detail_list.length - 1" height="10">
              <v-icon class="mt-1" size="3" color="placeholder" style="position: absolute; left: 22.5px;">mdi-circle</v-icon>
              <v-divider vertical class="my-0" />
              <v-icon class="mb-n1" size="3" color="placeholder" style="left: -0.4px; top: 7px">mdi-circle</v-icon>
            </v-sheet>
          </div>
        </v-card-text>
        <v-divider />
        <v-card-actions class="py-2 px-5">
          <v-spacer/>
          <v-btn color="blue-500" @click="dialogSunat=false" :ripple="false">Aceptar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- end dialog STATUS SUNAT -->

    <!-- dialog confirm reprocesar -->
    <v-dialog v-model="dialogReprocessDoc" width="792" persistent no-click-animation overlay-color="grey-500">
      <v-card>
        <v-card-title class="pa-0">
          <v-toolbar flat height="46" class="transparent">
            <v-toolbar-title class="px-5 subtitle-2 grey-700--text font-weight-semibold">Re-procesar documento</v-toolbar-title>
            <v-spacer />
            <v-toolbar-items>
              <v-row align="center" justify="center" class="mr-3">
                <v-btn @click="dialogReprocessDoc=false" icon small retain-focus-on-click><v-icon color="grey-500" size="20">mdi-close</v-icon></v-btn>
              </v-row>
            </v-toolbar-items>
          </v-toolbar>
        </v-card-title>
        <v-divider />
        <v-card-text class="py-4 px-5 grey-500--text">
          <v-row class="pt-2 pb-4" align="center">
            <v-col cols="3">
              <img :src="require(`@/assets/backgrounds/modal-document-null.svg`)" :width="148" />
            </v-col>
            <v-col class="pr-4 pl-4">
              <div class="mt-1 mb-3">
                <v-icon class="mr-2" color="grey-700" size="14">mdi-file-document</v-icon><span class="body-2 font-weight-medium text-uppercase">{{((instance || {}).type || '') | nameDocumentsType}} {{((instance || {}).document_type || '') | nameDocumentsType}} Nº{{instance.number}}</span>
              </div>
              <span class="d-block body-1 pt-2">Al confirmar, se enviará nuevamente este documento a la {{$t('generals.SII')}} para su revisión y aceptación. Esta acción no se puede deshacer.</span>
              <span class="d-block body-1 mt-4 mb-3">Escribe <span class="font-weight-bold">“confirmar”</span> para continuar.</span>
              <v-text-field v-model="confirm" outlined single-line maxlength="9" dense hide-details />
            </v-col>
          </v-row>
        </v-card-text>
        <v-divider />
        <v-card-actions class="py-2 px-5">
          <v-spacer/>
          <v-btn @click="dialogReprocessDoc=false" outlined>Cancelar</v-btn>
          <v-btn color="blue-500" @click="reprocessDoc" :loading="loadingReprocessDoc" :disabled="confirm.toLowerCase() !== 'confirmar' ">Confirmar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- end dialog confirm reprocesar -->

    <!-- dialog pdf -->
    <v-dialog v-model="modalPDF" width="700" persistent :scrollable="true" no-click-animation overlay-color="grey-500">
      <render-pdf :basicRender="true" :documentType="((instance || {}).type || '') | nameDocumentsType" :number="instance.number" @close="modalPDF=false" :loaderRender="loaderRender" :renderUrl="renderUrl" :flat="true" :formatPDF.sync="formatPDF" :showFormat="true" :templates="pdfTemplates" :selectedTemplate.sync="selectedTemplate" :showTemplateSelector="true" />
    </v-dialog>
    <!-- end dialog pdf -->

    <!-- dialog send email new ui -->
    <v-dialog v-model="modalEmail" width="700" persistent no-click-animation overlay-color="grey-500">
      <v-card>
        <v-card-title class="pa-0">
          <v-toolbar class="transparent" flat height="46">
            <v-toolbar-title class="px-5 subtitle-2 grey-500--text font-weight-semibold">Enviar por mail</v-toolbar-title>
            <v-spacer />
            <v-toolbar-items>
              <v-row align="center" justify="center" class="mr-3">
                <v-btn @click="modalEmail=false" icon small retain-focus-on-click><v-icon color="grey-500" size="20">mdi-close</v-icon></v-btn>
              </v-row>
            </v-toolbar-items>
          </v-toolbar>
        </v-card-title>
        <v-divider />
        <v-card-text class="px-5 py-4">
          <v-list class="v-list-form pa-0 transparent">
          </v-list>
          <div class="d-flex align-center">
            <span class="grey-500--text body-1" style="min-width: 60px;">Para</span>
            <v-combobox class="a-combobox" ref="email" v-model="messages.recipient" :key="key" hide-details :items="emailsList" outlined required hide-selected :placeholder="!messages.recipient.length ? 'Escribe el email del destinatario' : ''" @update:search-input="setEmail"  multiple deletable-chips small-chips dense single-line autocomplete="off">
              <template v-slot:selection="data">
                <v-chip class="pr-2 ma-1 close-chip" color="blue-100" v-bind="data.attrs" :input-value="data.selected" close @click="data.select" @click:close="remove(data.item)" small>{{ data.item }}</v-chip>
              </template>
              <template v-slot:item="data">
                <v-list-item-avatar>
                  <v-icon color="grey-700">mdi-account-circle</v-icon>
                </v-list-item-avatar>
                <v-list-item-title class="ml-n2 font-weight-medium" v-html="data.item"></v-list-item-title>
              </template>
            </v-combobox>
          </div>
        </v-card-text>
        <v-divider />
        <v-card-actions class="py-2 px-5">
          <v-spacer/>
          <v-btn @click="modalEmail=false" outlined>Cancelar</v-btn>
          <v-btn @click="createMessages" :loading="$store.state.messages.createLoader" color="blue-500">Enviar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- end dialog -->
  </v-row>
</template>

<script>
  import { mapState } from 'vuex'
  import MiniHeader from '@/components/commons/MiniHeader'
  import { email, minLength, maxLength, required } from 'vuelidate/lib/validators'
  import { rutValidator } from 'vue-dni'
  import { rutFormat } from 'rut-helpers'
  import ChipStatus from '@/components/commons/ChipStatus'
  import VModal from '@/components/commons/VPanel'
  import SkeletonDetail from '@/components/commons/skeletonLoader/SkeletonDetail'
  import RenderPdf from '@/components/files/RenderPdf'
  import DocumentsList from '@/modules/documents/components/DocumentsList'
  import DocumentEvents from '@/collections/documentEvents'
  import DistEvents from '@/collections/distEvents'
  import GenericViewMixin from '@/mixins/GenericViewMixin'
  import RenderViewMixin from '@/mixins/RenderViewMixin'
  import TaxAgencyViewMixin from '@/mixins/TaxAgencyViewMixin'
  import DocumentTypes from '@/collections/documentTypes'
  import numeral from 'numeral'
  import moment from 'moment'
  import VEmptyState from '@/components/commons/VEmptyState'
  import cloneDeep from 'lodash/cloneDeep'
  const REGEX = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/

  export default {
    mixins: [
      GenericViewMixin,
      RenderViewMixin,
      TaxAgencyViewMixin
    ],
    components: {
      VEmptyState,
      ChipStatus,
      VModal,
      SkeletonDetail,
      RenderPdf,
      DocumentsList,
      MiniHeader
    },
    data: () => ({
      references: [],
      key: 0,
      emailsList: [],
      dialogReprocessDoc: false,
      loadingReprocessDoc: false,
      dialogSunat: false,
      link: 'https://docs.axteroid.com/',
      eventLoading: false,
      // events: [],
      showMoreEvents: false,
      distEventsList: [],
      distEventLoading: false,
      showMoreDistEvents: false,
      confirm: '',
      dialogMarkAsAnulled: false,
      loadingAnulled: false,
      actionCreateDoc: '',
      cloneDoc: '',
      noteReason: '',
      createDocumentDialog: false,
      formatPDF: 1,
      loadingDetail: false,
      loading: false,
      scroll: 0,
      activePanel: false,
      dialogDetailAssign: false,
      dialogLoadingAssign: false,
      loadingAssign: false,
      grant: {
        assigneeTaxId: '',
        assigneeName: '',
        assigneeAddress: '',
        assigneeEmail: '',
        assignorEmail: '',
        assignorName: '',
        assignorTaxId: ''
      },
      dialogGrant: false,
      dialogCreditNote: false,
      dialogMessages: false,
      loadingDocumentsDuplicate: false,
      panelIrsSii: [],
      panelRelatedDocuments: false,
      panelTotals: false,
      modalEmail: false,
      panelComments: false,
      modalPDF: false,
      comments: '',
      messages: {
        text: '',
        recipient: '',
        subject: '',
        type: ['pdf', 'xml']
      },
      documentsCanBeCreated: {
        CL33: ['CL61', 'CL56'],
        CL34: ['CL61', 'CL56'],
        CL39: ['CL61', 'CL56'],
        CL42: ['CL61', 'CL56'],
        CL46: ['CL61', 'CL56'],
        CL56: ['CL61'],
        CL61: ['CL56'],
        CL110: ['CL112', 'CL111'],
        CL111: ['CL112'],
        CL112: ['CL111'],
        CL41: ['CL61', 'CL56']
      },
      DocumentTypesList: DocumentTypes,
      breadcrumbs: {
        main: 'Emisión',
        children: [
          {
            text: 'Documentos',
            route: 'DocumentsList'
          }
        ]
      }
    }),
    computed: {
      ...mapState({
        instance: state => state.documents.documentsDetail,
        supplierresponsesList: state => state.irs.supplierresponsesList,
        creditnotesList: state => state.documents.creditnotesList,
        debitnotesList: state => state.documents.debitnotesList,
        eventsList: state => state.documents.eventsList,
        contactsList: state => state.customers.contactsList,
        count: state => state.documents.documentsCount,
        documentsList: state => state.documents.documentsList
      }),
      totalCredits () {
        return this.sumProperty(this.creditnotesList, 'total')
      },
      totalDebits () {
        return this.sumProperty(this.debitnotesList, 'total')
      },
      totalAdjustedDocuments () {
        return this.instance.total - this.totalCredits + this.totalDebits
      },
      totalPaid () {
        return this.instance.payments.length ? this.instance.payments.map(c => c.amount_paid).reduce((a, b) => a + b) : 0
      },
      activeDocument () {
        return DocumentTypes.find((d) => d.id === this.instance.type)
      },
      checkPermissionDTE () {
       return (dte) => {
          if (!this.$store.state.accounts.me?.is_owner && !this.$store.state.auth.userAccount.is_staff) {
            /* eslint-disable */
            const ownGroupPermissions = [...(this.$store.state.accounts.me?.document_type_permissions ?? []), ...(this.$store.state.accounts.me?.groups?.map(({document_type_permissions}) => document_type_permissions)[0] ?? [])]
            return ownGroupPermissions.filter((item) => item.document_type === dte.id)
          }
          return true
        }
      },
      events () {
        return !this.showMoreEvents ? this.eventsList.slice(0,3) : this.eventsList
      },
      distEvents () {
        return !this.showMoreDistEvents ? this.distEventsList.slice(0, 3) : this.distEventsList
      },
      distEventTypeLabel () {
        return (type) => {
          const labels = { SNT: 'Enviado', DLR: 'Entregado', NST: 'No enviado', BOU: 'Rebotado', OPN: 'Leído', REJ: 'Rechazado' }
          return labels[type] || type
        }
      },
      distSourceTypeLabel () {
        return (type) => {
          const labels = { AUT: 'automáticamente', MAN: 'manualmente', VOI: 'por baja', CSM: 'normativamente', REC: 'por acuse de recibo', RCO: 'por comprobante comercial' }
          return labels[type] || type
        }
      },
      currentDistEvent () {
        return (sourceType) => {
          return DistEvents.find(({id}) => sourceType === id) ?? {}
        }
      },
      currentEvent () {
        return (val) => {
          return DocumentEvents.find(({id}) => val === id) ?? {}
        }
      },
      currentParams () {
        let params = JSON.parse(JSON.stringify(this.$route.params))
        delete params.id
        return params
      },
      isApprovedOrObserved () {
        if (this.loadingDetail || !this.instance?.status) return false
        return ['APR', 'OBS'].includes(this.instance.status)
      },
      availableNotes () {
        if (this.loadingDetail || !this.instance?.type) {
          return []
        }
        
        const docType = this.instance.type
        const isApproved = this.isApprovedOrObserved
        
        if (!isApproved) {
          return []
        }
        return this.documentsCanBeCreated[docType] || []
      }
    },
    watch: {
      modalPDF (val) {
        this.modalRender = val
        if (!this.renderUrl) this.renderDocument2('documents')
        this.formatPDF = 1
        if (val && this.instance?.type) this.fetchPdfTemplates(this.instance.type)
        if (!val) {
          this.selectedTemplate = null
          this.pdfTemplates = []
        }
      },
      selectedTemplate (val) {
        if (!val) return
        const query = { template: val.template }
        if (this.formatPDF !== 1) query.thermal_format = this.formatPDF
        this.renderDocument2('documents', null, '', this.$route.params.id, query)
      },
      dialogGrant (val) {
        if (val) {
          this.$v.grant.$reset()
          this.grant.assignorName = this.$store.state.auth.account.name
          this.grant.assignorTaxId = this.$store.state.auth.account.tax_id
          this.grant.assignorEmail = this.$store?.state?.auth?.userAccount.email
        }
      }
    },
    created () {
      this.activePanel = true
      this.retrieve()
    },
    methods: {
      formatRut (rut) {
        if (!rut) return ''
        if (this.$store.state.auth.account.country === 'CL') {
          return rutFormat(rut)
        }
        return rut
      },
      goTo (item = null) {
       this.$store.commit('base/SET_QUERY', { type: item.type, series: item.series, serial: item.serial, _name: this.instance.number, ref: this.instance.id })
       this.$router.push({ name: 'DocumentsList', params: { id: this.instance.id, ...this.currentParams }, query: { type: item.type, series: item.series, serial: item.serial, _name: this.instance.number, ref: this.instance.id }})
     },
      setEmail (e) {
        let array = []
        this.emailsList = []

        if (e?.length) {
          let elm = e.replace(/ /g, ',')
          array = [...array, ...elm.split(',')]
          array = array.filter((item) => Boolean(item))

          if (array.length === 1) {
            if (REGEX.test(e)) {
              this.emailsList.push(e)
              this.emailsList = [...new Set([...this.emailsList])]
            }
          } else {
            this.key += 1
            this.messages.recipient = [...this.messages.recipient, ...array.filter(item => REGEX.test(item))]
            this.messages.recipient = [...new Set(this.messages.recipient)]
          }
        }
      }, 
      remove (item) {
        const index = this.messages.recipient.indexOf(item)
        if (index >= 0) {
          this.messages.recipient.splice(index, 1)
        }
      },
      onScroll (e) {
        this.scroll = e.target?.scrollingElement?.scrollTop ?? 0
      },
      reprocessDoc () {
        this.loadingReprocessDoc = true
        this.$store.dispatch('documents/GET', {
          resource: `documents/${this.$route.params.id}/reprocess`
        })
        .then(() => {
          this.$dialog.message.info('El documento fue reprocesado con éxito.')

          setTimeout(() => {
            this.retrieve()
          }, 600)
        })
        .catch((error) => {
          this.$dialog.message.error(error.response.data.message)
        })
        .finally(() => {
          this.confirm = ''
          this.loadingReprocessDoc = false
          this.dialogReprocessDoc = false
        })
      },
      markAsAnulled () {
        this.loadingAnulled = true
        this.$store.dispatch('documents/GET', {
          resource: `documents/${this.$route.params.id}/void`
        })
        .then(() => {
          this.$dialog.message.info('El documento se marco como nulo con exito')

          setTimeout(() => {
            this.retrieve()
          }, 600)
        })
        .catch((error) => {
          this.$dialog.message.error(error.response.data.message)
        })
        .finally(() => {
          this.confirm = ''
          this.loadingAnulled = false
          this.dialogMarkAsAnulled = false
        })
      },
      handlerClone (doc = '') {
        this.createDocumentDialog = true
        this.cloneDoc = doc
        this.actionCreateDoc = ''
        this.noteReason = ''
      },
      handlerNoteClick (docType) {
        if (['CL56', 'CL61', 'CL112', 'CL111'].includes(docType)) {
          this.handlerClone(docType)
        } else {
          const query = {
            document_type: docType,
            document_parent: this.instance.type,
          }
          this.$router.push({
            name: 'DocumentsClone',
            params: { id: this.instance.id, ...this.$route.params },
            query: query
          })
        }
      },
      getNoteLabel (docType) {
        const labels = {
          'CL61': 'Emitir nota de crédito (61)',
          'CL56': 'Emitir nota de débito (56)',
          'CL112': 'Emitir nota de crédito exportación (112)',
          'CL111': 'Emitir nota de débito exportación (111)'
        }
        return labels[docType] || this.DocumentTypesList.find((d) => d?.id === docType)?.name || docType
      },
      closeCreateDocumentDialog () {
        this.createDocumentDialog = false
        this.actionCreateDoc = ''
        this.noteReason = ''
        this.cloneDoc = ''
      },
      createNoteDocument () {
        if (!this.actionCreateDoc || !this.noteReason) {
          return
        }
        const query = {
          document_type: this.cloneDoc,
          document_parent: this.instance.type,
          action: this.actionCreateDoc,
          reason: this.noteReason,
          ...(this.instance.type === 'CL39' && { origin: this.instance.type })
        }
        this.$router.push({
          name: 'DocumentsClone',
          params: { id: this.instance.id, ...this.$route.params },
          query
        })
      },
      retrieve () {
        this.loadingDetail = true
        this.$store.dispatch('documents/RETRIEVE', {
          resource: 'documents',
          id: this.$route.params.id
        })
        .then((response) => {
          this.references = response.data.references
          this.eventLoading = true
          this.getEvents()
          this.getDistEvents()
          this.messages.subject = `Envía ${this.activeDocument?.name ?? ''} N° ${this.instance.number}`
          this.messages.text = `Estimado cliente, ${this.instance?.customer_name ?? ''},\n\n`
          this.messages.text += `Adjunto ${this.activeDocument?.name ?? ''} N° ${this.instance.number}, `
          this.messages.text += `correspondiente al ${moment(this.instance?.date).format('DD MMM YYYY')} `
          this.messages.text += `por un monto de ${numeral(this.instance?.amount_total).format('0,0')} ${this.instance?.exchange?.currency_from ?? this.instance?.exchange?.currency_to ?? this.activeDocument?.currencies[0] ?? ''} \n\nAtentamente ${this.account?.name}`
        })
        .finally(() => {
          this.loadingDetail = false
        })
      },
      getEvents () {
        this.eventLoading = true
        this.$store.dispatch('documents/LIST', {
          resource: `documents/${this.instance.id}/events`
        })
        .finally(() => {
          this.eventLoading = false
        })
      },
      getDistEvents () {
        this.distEventLoading = true
        this.$store.dispatch('documents/GET', {
          resource: `documents/${this.instance.id}/dist-events`
        })
        .then((response) => {
          this.distEventsList = response.data || []
        })
        .catch(() => {
          this.distEventsList = []
        })
        .finally(() => {
          this.distEventLoading = false
        })
      },
      createCreditNote () {
        this.$v.creditNote.$touch()
        if (this.$v.creditNote.$invalid) {
          return false
        }
        this.$store.dispatch('documents/CREATE', {
          resource: 'creditnotes',
          payload: {
            documents: this.instance.id,
            note: this.creditNote.note
          }
        })
        .then(() => {
          this.dialogCreditNote = false
          this.retrieve()
        })
        .catch((error) => {
          this.$dialog.message.error(error.response.data.message)
        })
      },
      createMessages () {
        this.messages.document = this.instance.id
        this.messages.type = this.messages.type.length === 2 ? 'all' : this.messages.type.toString()

        this.$v.messages.$touch()
        if (this.$v.messages.$invalid) {
          return false
        }
        this.$store.dispatch('messages/CREATE', {
        resource: 'documents/distribute',
        query: this.$route.query,
        payload: {
          document_ids: [this.$route.params.id],
          email:  this.messages.recipient.toString()
        }
      })
      .then(() => {
        this.$dialog.message.info('El envío de documentos por email se realizó con éxito')
        this.messages.recipient = ''
        this.messages.type = []
      })
      .catch((error) => {
        this.$dialog.message.error(error.response.data.message)
      })
      .finally(() => {
        this.modalEmail = false
        setTimeout(() => {
          this.getEvents()
          this.getDistEvents()
        }, 3000)
      })
      },
      createExport () {
        this.$store.dispatch('accounts/DOWNLOAD', {
          resource: 'documents/download',
          query: this.$route.query,
          payload: {
            document_ids: [this.$route.params.id]
          }
        })
        .then(() => {
          this.$dialog.message.info('La descarga se ha realizado con éxito.')
        })
        .catch(() => {
          this.$dialog.message.error('Ha ocurrido un error en el proceso de descarga')
        })
    },
      createGrant () {

        this.$v.grant.$touch()
        if (this.$v.grant.$invalid) {
          return false
        }
        this.dialogGrant = false
        this.dialogLoadingAssign = true
        this.loadingAssign = true

        const payload = {
          ...this.grant,
          assigneeTaxId: this.grant.assigneeTaxId.replace(/\./g, ''),
          assignorTaxId: this.grant.assignorTaxId.replace(/\./g, '')
        }

        this.$store.dispatch('irs/UPDATE', {
          resource: `documents/${this.$route.params.id}/assign`,
          payload: payload
        })
        .then((response) => {
          this.grant = response.data
          this.dialogGrant = false
          this.$dialog.message.info('La cesión del documento se ha realizado con éxito')
        })
        .catch((error) => {
          this.$dialog.message.error(error.response.data.message)
        })
        .finally(() => {
          setTimeout(() => {
            this.retrieve()
            this.loadingAssign = false
            this.dialogLoadingAssign = false
          }, 4000)
        })
      },
      cloneDocuments () {
        const dueDate = moment(this.today).add(30, 'days').format('YYYY-MM-DD')
        const payload = cloneDeep(this.instance)
        delete payload.id
        delete payload.imported
        delete payload.local_file
        delete payload.metadata
        delete payload.number
        delete payload.status
        delete payload.subscription
        delete payload.irs
        delete payload.test_mode
        delete payload.created
        delete payload.updated
        payload.collection_method = 'deferred'
        payload.customer = this.instance.customer.id
        payload.date = this.today
        payload.document = this.instance.document.id
        payload.due_date = dueDate
        payload.lines.map((line) => {
          Object.keys(line).forEach((key) => {
            if (['created', 'id', 'documents', 'updated', 'total', 'total_adjusted'].includes(key)) {
              delete line[key]
            }
            if (!line.discount) {
              line.discount = 0
              line.discount_scheme = '%'
            }
          })
          return line
        })
        payload.payments = [{
          amount: this.instance.total,
          date: dueDate,
          description: 'Pago de factura',
          currency: this.instance.type
        }]
        this.loadingDocumentsDuplicate = true
        this.$store.dispatch('documents/CREATE', {
          resource: 'documents',
          payload: payload
        })
        .then((response) => {
          this.$router.push({ name: 'DocumentsRetrieve', params: {id: response.data.id, ...this.$route.params} })
        })
        .catch((error) => {
          this.$dialog.message.error(error.response.data.message)
        })
        .finally(() => {
          this.loadingDocumentsDuplicate = false
        })
      },
      builtInSupllierResponses () {
        this.$store.dispatch('irs/CREATE', {
          resource: 'irs/sii/supplierresponses',
          payload: {
            documents: this.instance.id
          }
        })
        .catch((error) => {
          this.$dialog.message.error(error.response.data.message)
        })
      },
      updateCollectible () {
        let dialogTitle = 'Marcar como incobrable'
        let dialogMsg = 'Esta factura no será considerada como pendiente de pago, pero será posible pagarla si el cliente lo intenta.'
        let successMsg = 'La factura se marcó como incobrable'
        if (this.instance.status === 'uncollectible') {
          dialogTitle = 'Marcar como cobrable'
          dialogMsg = 'Esta factura volverá a ser considerada como pendiente de pago.'
          successMsg = 'La factura se marcó como cobrable'
        }
        this.$dialog.warning({
          title: dialogTitle,
          text: `
            <span class="d-block mb-4">${dialogMsg}</span>
            <span class="d-block">¿Estás seguro de continuar?</span>
          `,
          actions: [
            {
              color: 'red',
              text: 'Continuar',
              handle: () => {
                this.$store.dispatch('documents/RETRIEVE', {
                  resource: 'documents',
                  id: this.$route.params.id,
                  detail: 'uncollectible',
                  loader: false
                })
                .then(() => {
                  this.$dialog.message.info(successMsg)
                })
                .catch((error) => {
                  this.$dialog.message.error(error.response.data.message)
                })
              }
            }
          ]
        })
      }
    },
    validations: {
      messages: {
        recipient: {
          required
        },
        subject: {
          required,
          minLength: minLength(6),
          maxLength: maxLength(60)
        },
        text: {
          required
        }
      },
      grant: {
        assigneeTaxId: {
          required,
          maxLength: maxLength(32),
          rutValidator
        },
        assigneeName: {
          required,
          maxLength: maxLength(100)
        },
        assigneeAddress: {
          required,
          maxLength: maxLength(70)
        },
        assigneeEmail: {
          required,
          email,
          maxLength: maxLength(70)
        },
        assignorEmail: {
          required,
          email,
          maxLength: maxLength(70)
        },
        assignorName: {
          required,
          maxLength: maxLength(100)
        },
        assignorTaxId: {
          required,
          maxLength: maxLength(70),
          rutValidator
        }
      }
    }
  }
</script>
<style>
.textarea-email.v-text-field--enclosed .v-input__append-inner {
  align-self: end;
  padding: 10px 0;
}
</style>